import { MoaConfig } from '@submodules/MOA/moa.config';

export const getServerYiiUrl = (moaConfig: MoaConfig): string => {
    return moaConfig.urlYii;
};
